export function format(value: any): string {
  return String(value).replace(',', '.');
}
